module.exports = __webpack_public_path__ + "static/media/ChannelsIconBlack.1b9732e8.svg";